<template>
  <div class="row">
    <div class="Ticket" id="Ticket">

      <!-- Ticket -->
      <div @click="selectText" class="pageBreak ticket-container" v-if="currentTicket == 0">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-12 d-flex justify-content-center">
              <h1>TACOS HERIS</h1>
            </div> -->
              <div class="col-12 d-flex justify-content-center">
                <h2 class="table-normal-body">JULIETA ESTEFANIA ARRIETA CASTAÑEDA</h2>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3 class="table-normal-body">RFC: AICJ920927E11</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3 class="text-center table-normal-body">
                  <!-- ALBERTO TERRONES BENITEZ NUM 406 SUR ZONA CENTRO DURANGO DURANGO -->
                  {{sucursal.direccion}}
                </h3>
              </div>
              <div class="col-12 d-flex justify-content-center tipo-consumo-container">
                <div class="tipo-consumo">
                  <p class="text-uppercase align-self-center">CONSUMO {{getConsumo(orden.orden.tipoConsumo)}}</p>

                  <div v-if="orden.orden.tipoConsumo == 'domicilio'">                  
                      <div class="text-justified table-normal-body"><pre>{{ getDomicilio() }}</pre></div>                  
                  </div>
                  
                  <div v-if="orden.orden.tipoConsumo == 'sucursal'">
                    <div class="text-center table-normal-body"><pre> Mesa #{{orden.orden.mesa}}</pre></div>
                  </div>

                  <div v-if="orden.orden.tipoConsumo == 'recoger'">                  
                    <div class="text-center table-normal-body"><pre> Nombre: {{orden.orden.nombreCliente}}, <br> Teléfono: {{orden.orden.telefonoCliente}}</pre></div>                  
                  </div>

                  <div v-if="orden.orden.tipoConsumo == 'llevar'">                  
                    <div class="text-center table-normal-body"><pre> Nombre: {{orden.orden.nombreCliente}} </pre></div>                  
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont">
                <h3>FOLIO:{{ orden.orden.folio }}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center mb-3">
                <h3 class="table-normal-body">{{ orden.orden.datetime }}</h3>
              </div>
            </div>

            <!-- <table
              v-for="(cuenta, cIdx) in cuentas"
              v-bind:key="cIdx"
              class="detalle mb-5"
            >
              <thead>
                <tr>
                  <th style="font-weight: unset !important" class="text-center">
                    Cantidad
                  </th>
                  <th style="font-weight: unset !important" class="text-center">
                    Concepto
                  </th>
                  
                  <th style="font-weight: unset !important" class="text-right">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(plato, pIdx) in cuenta" v-bind:key="pIdx">
                  <td class="text-center">{{ plato.cantidad }}</td>
                  <td>{{ plato.nombre }}</td>

                  <td class="text-right">
                    {{ calculaPrecio(plato.precio, plato.cantidad) }}.00
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Total</td>
                  <td class="text-right">
                    <strong> ${{ orden.aPagarTotal }}.00</strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Recibido</td>
                  <td class="text-right">
                    <strong> ${{ orden.cantidadEntregada }}.00</strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Cambio</td>
                  <td class="text-right">
                    <strong> ${{ orden.cambio }}.00</strong>
                  </td>
                </tr>
              </tbody>
            </table> -->
            
            <div style="padding-right:15px">
            <table class="detalle mb-5">
              <thead>
                <tr>
                  <th class="text-center table-bold-header mb-1" width="30px">
                    Cant
                  </th>
                  <th class="text-center table-bold-header mb-1" width="350px">
                    Concepto
                  </th>
                  <th class="text-right table-bold-header mb-1" width="75px">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(plato, pIdx) in cuentas2" v-bind:key="pIdx" style="margin-bottom: 9px;">
                  <td class="text-center mb-2">
                    <div class="mb-2 table-normal-body">{{ plato.cantidad }}</div>
                  </td>
                  <td>
                    <div class="mb-2 table-normal-body" >{{ plato.nombre }}</div>
                  </td>

                  <td class="text-right">
                    <div class="table-normal-body">{{ calculaPrecio(plato.precio, plato.cantidad) }}.00</div>
                  </td>
                </tr>
                <tr v-if="orden.consumo == 'domicilio'">
                  <td></td>
                  <td class="text-right table-bold-header">
                    <div class="mb-2 mt-2">Cobro Envio</div>
                  </td>
                  <td class="text-right">
                    <div class="mb-2 mt-2"> <strong> ${{ orden.cobroEnvio }}.00</strong> </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right table-bold-header">
                    <div class="mb-2 mt-2">Total</div>
                  </td>
                  <td class="text-right">
                    <div class="mb-2 mt-2"> <strong> ${{ orden.aPagarTotal }}.00</strong> </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right"><div class="mb-2 mt-2 table-normal-body">Recibido</div></td>
                  <td class="text-right">
                    <div class="mb-2 mt-2 table-normal-body">${{ orden.cantidadEntregada }}.00</div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right"><div class="mb-2 mt-2 table-normal-body">Cambio</div></td>
                  <td class="text-right">
                     <div class="mb-2 mt-2 table-normal-body">${{ orden.cambio }}.00</div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>

            <div class="col-12 d-flex justify-content-center mt-2 dashed-top">
              <div class="mt-2">
              <h3 class="text-center table-normal-body">
                -- GRACIAS POR SU PREFERENCIA --
              </h3>
              </div>
            </div>
            <!-- <span class="mb-3"></span> -->
          </div>
        </div>
      </div>

      <!-- Comanda General -->
      <div class="pageBreak ticket-container mb-3" style="padding-top: 20px;" v-if="currentTicket == 1">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic"
                  style="margin-top: 20px; margin-bottom: 5px"
                >
                  <img :src="logo" width="99" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda General</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>ORDEN:{{ orden.orden.id }} / FOLIO DIARIO {{orden.orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ orden.orden.datetime }}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex justify-content-center">
                <h3>Pastor</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Molleja</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Asada</h3>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TP" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TM" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TA" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Restop" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>
          </div>
        </div>
        <h1> </h1>
      </div>
      
      <!-- Comanda Tacos -->
      <div class="pageBreak ticket-container mb-3" style="padding-top: 20px;" v-if="currentTicket == 2">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic"
                  style="margin-top: 20px; margin-bottom: 5px"
                >
                  <img :src="logo" width="99" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Tacos</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>ORDEN:{{ orden.orden.id }} / FOLIO DIARIO: {{ orden.orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ orden.orden.datetime }}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex justify-content-center">
                <h3>Pastor</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Molleja</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Asada</h3>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TP" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TM" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in TA" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
            </div>

          </div>
        </div>
        <h1> </h1>
      </div>

      <!-- Comanda Burros / Especiales -->
      <div class="pageBreak ticket-container mb-3" style="padding-top: 20px;" v-if="currentTicket == 3">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic"
                  style="margin-top: 20px; margin-bottom: 5px"
                >
                  <img :src="logo" width="99" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Burritos</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>ORDEN:{{ orden.orden.id }} / FOLIO DIARIO: {{ orden.orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ orden.orden.datetime }}</h3>
              </div>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Burritos" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Especiales" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

          </div>
        </div>
        <h1> </h1>
      </div>

      <!-- Comanda Cebollitas -->
      <div class="pageBreak ticket-container mb-3" style="padding-top: 20px;" v-if="currentTicket == 4">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic"
                  style="margin-top: 20px; margin-bottom: 5px"
                >
                  <img :src="logo" width="99" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Cebollitas</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>ORDEN:{{ orden.orden.id }} / FOLIO DIARIO: {{ orden.orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ orden.orden.datetime }}</h3>
              </div>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Cebollitas" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

          </div>
        </div>
        <h1> </h1>
      </div>

    </div>

    <div id="NoTicket" class="col ml-5">
      <button
        @click="home"
        type="button"
        class="btn btn-secondary btn-lg waves-effect waves-light"
      >
        Inicio
      </button>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import PrintCuenta from "@/modules/printer/models/PrintCuenta.js";
import Sucursal from '@/modules/restaurant/models/Sucursal.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: "PrintTicket",

  props: ["orden", "cuentas"],
  mounted() {
    var sid = Sucursal.getSucursal()
    if(sid == null){
      console.log("error en sucursal")
    }else{
      let _this = this;
      console.log("orden", this.orden);
      // this.cuentas = cuentas;
      console.log("cuentas", this.cuentas);
      _this.unirCuentas();
      _this.sucursal = sid
    }
       
  },
  data() {
    return {
      title: "Cerrar cuenta",
      logo: "/img/WideLogo.png",
      cuentas2: [],
      TA: [],
      TP: [],
      TM: [],
      Burritos: [],
      Cebollitas: [],
      Restop: [],
      Especiales: [],
      currentTicket: -1,
      sucursal: null,
    };
  },
  components: {
    // SideMenu,
    // TopBar,
    Alert,
  },
  methods: {
    unirCuentas() {
      const t = this;
      t.cuentas2 = [];
      Object.keys(this.cuentas).forEach((current) => {
        this.cuentas[current].map((subCurrent) => {
          t.cuentas2.push(subCurrent);
        });
      });
      console.log("cuentas222");
      console.log(t.cuentas2);
      
      setTimeout(()=>{
        this.currentTicket = 0;
        setTimeout(()=>{
          window.print()
        }, 400);
      }, 300);
    },
    printSection() {
      this.$htmlToPaper("printSection");
    },
    calculaPrecio(precio, cantidad) {
      return parseFloat(precio) * parseFloat(cantidad);
    },
    getDetalleOrden() {
      let detalleConcepto = [];

      Object.keys(this.cuentas).forEach((current) => {
        this.cuentas[current].map((subCurrent) => {
          let cadena = `   ${
            subCurrent.cantidad
          }   ${subCurrent.nombre.toUpperCase()}   ${subCurrent.precio}`;
          detalleConcepto.push(cadena);
        });
      });
      return detalleConcepto;
    },
    home() {
      this.$router.push({ name: "ResHerisOrdenesGrid" });
    },
    print() {
      this.selectText();
      let selection = window.getSelection();
      console.log(selection.toString());

      setTimeout(function () {
        window.print();
      }, 2000);
    },
    selectText() {
      let id = "Ticket";
      var sel, range;
      var el = document.getElementById(id); //get element id
      if (window.getSelection && document.createRange) {
        //Browser compatibility
        sel = window.getSelection();
        if (sel.toString() == "") {
          //no text selection
          window.setTimeout(function () {
            range = document.createRange(); //range object
            range.selectNodeContents(el); //sets Range
            sel.removeAllRanges(); //remove all ranges from selection
            sel.addRange(range); //add Range to a Selection.
          }, 1);
        }
      } else if (document.selection) {
        //older ie
        sel = document.selection.createRange();
        if (sel.text == "") {
          //no text selection
          range = document.body.createTextRange(); //Creates TextRange object
          range.moveToElementText(el); //sets Range
          range.select(); //make selection.
        }
      }
    },
    guardar() {
      // var ePosDev = new epson.ePOSDevice();
      // console.log(ePosDev);
      // this.$htmlToPaper('printMe');

      // html2canvas(document.body).then(function (canvas) {
      //   var imgData = canvas.toDataURL("image/jpeg", 1.0);
      //   var pdf = new jsPDF("p", "mm", [400, 480]);
      //   pdf.addImage(imgData, "JPEG", 0, 0, 400, 480);
      //   pdf.save("screen-3.pdf");
      // });

      // var pdf = new jsPDF("p", "mm", "a4");
      // pdf.html(document.getElementById("Ticket"), {
      //   callback: function (pdf) {
      //     pdf.save("a4.pdf");
      //   },
      // });

      // const doc = new jsPDF();
      // const contentHtml = this.$refs.content.innerHTML;
      // doc.fromHTML(contentHtml, 15, 15, {
      //   width: 170,
      // });
      // doc.save("sample.pdf");

      // ***************************************************************************************
      let prtHtml = document.querySelector("#Ticket").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
         <html>
         <head>
            <link rel="stylesheet" href="http://localhost:8080/css/boostrap.min.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/hamburguesa.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/style.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/my_style.css/">
        <style>
        * {
            background: white !important;
            color: black !important;
          }
        </style>
        </head>
        
        <body>
        ${prtHtml}
        </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      // setTimeout(function(){
      // WinPrint.print();
      // WinPrint.close(); }, 2000);

      // WinPrint.print();
      // WinPrint.close();
      let bodyFormData = new FormData();
      bodyFormData.append("html", WinPrint);

      let params = {
        html: bodyFormData,
      };
      console.log("BodyFormData");
      console.log(bodyFormData);
      PrintCuenta.pagarV2(bodyFormData, (resPDF) => {
        let pdfWindow = window.open("");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf, " +
            escape(resPDF.data) +
            "'></iframe>"
        );
      });
    },
    separarTacos(ordenes){
      ordenes.forEach((element) => {
        console.log(element.nombre)
        switch(element.nombre){
          case "taco de asada":
            this.TA.push(element.cantidad);
            break;
          case "taco de asada con queso":
            this.TA.push(element.cantidad+" C/Q");
            break;
          case "taco de pastor":
            this.TP.push(element.cantidad);
            break;
          case "taco de pastor con queso":
            this.TP.push(element.cantidad+" C/Q");
            break;
          case "taco de molleja":
            this.TM.push(element.cantidad);
            break;
          case "taco de molleja con queso":
            this.TM.push(element.cantidad+" C/Q");
            break;
          case "taco de pastor con piña":
            this.TP.push(element.cantidad+" P");
            break;
          case "taco de pastor con piña y queso":
            this.TP.push(element.cantidad+" P & C/Q");
            break;
          default:
            if(! (element.nombre.includes("agua ") || element.nombre.includes("refresco")) ){
              this.Restop.push(element.cantidad+" "+element.nombre)
            }
        }
      })
    },
    separarComandas(ordenes){
      ordenes.forEach((element) => {
        switch(element.nombre){
          case "taco de asada":
            this.TA.push(element.cantidad);
            break;
          case "taco de asada con queso":
            this.TA.push(element.cantidad+" C/Q");
            break;
          case "taco de pastor":
            this.TP.push(element.cantidad);
            break;
          case "taco de pastor con queso":
            this.TP.push(element.cantidad+" C/Q");
            break;
          case "taco de molleja":
            this.TM.push(element.cantidad);
            break;
          case "taco de molleja con queso":
            this.TM.push(element.cantidad+" C/Q");
            break;
          case "taco de pastor con piña":
            this.TP.push(element.cantidad+" P");
            break;
          case "taco de pastor con piña y queso":
            this.TP.push(element.cantidad+" P & C/Q");
            break;
          default:
            if(element.nombre.includes("burrito")){
              this.Burritos.push(element.cantidad+" "+element.nombre)
            }
            else if(element.nombre.includes("cebollitas")){
              this.Cebollitas.push(element.cantidad+" "+element.nombre)
            }
            else if(! (element.nombre.includes("agua ") || element.nombre.includes("refresco")) ){
              this.Especiales.push(element.cantidad+" "+element.nombre)
            }
        }
      })
    },
    getDomicilio(){
      let dom = this.orden.orden.cliente.resDomicilio
      var domPrincipal = `Domicilio: #${dom.numeroExt} ${dom.calle}, ${dom.colonia}.`;
      if(dom.entreCalles != ""){
        domPrincipal+= "\n"+`Entre calles: ${dom.entreCalles}.`
      }
      if(dom.entreCalles != ""){
        domPrincipal+= "\n"+`Referencia: ${dom.referencia}.`
      }
      return domPrincipal
    },
    getConsumo(id){
      if(id == "llevar"){
        return "para llevar"
      }
      if(id == "recoger"){
        return "para recoger"
      }
      if(id == "sucursal"){
        return "en sucursal"
      }
      return "a domicilio"
    }
  },
};
</script>

<style scoped>
* {
  background: white !important;
  color: black !important;
  font-weight: bold;
}
.rowTicket {
  padding-left: 10px;
}
/* .ticket {
  width: 80mm;
  border: 1px solid black;
  padding-left: 15px;
  margin-left: 16px;
} */

h1,
h2,
h3 {
  margin: 0;
}

h1 {
  font-size: 20px;
  font-family: "Times New Roman", Times, serif;
}
h2,
h3,
h4,
.detalle,
table,
th,
td {
  font-size: 12px !important;
  font-family: 'Fira Code', monospace;
  text-transform: uppercase;
}
.detalle {
  /* padding: 0!important; */
  margin: 0 auto;
}
.lista-tacos{
  text-align: center;
}

pre{
  all: initial;
  font-size: 12px !important;
  font-family: 'Fira Code', monospace;
  font-weight: 500 !important;
  text-transform: uppercase;
  color: black;
}

.tipo-consumo-container{
  border-top: 2px dashed black;
  border-bottom: 2px dashed black;
  margin: 8px 0;
}
.tipo-consumo{
  padding-top: 8px;
  padding-bottom: 8px;
}
.tipo-consumo > p{
  font-size: 18px !important;
  font-weight: bolder !important;
  margin-bottom: 4px;
}
.table-bold-header{
  font-weight: bolder !important;
}
.table-normal-body{
  font-weight: 500 !important;
}
.dashed-top{
  border-top:2px dashed black;
}
.folio-cont > h3{
  font-size: 22px !important;
}
@media print {
  .folio-cont > h3{
   font-size: 22px !important;
  }
  * {
    background: white !important;
    color: black !important;
    /* font-size: 14px; */
  }

  #NoTicket {
    display: none;
  }
  .ticket-container{
    width: 100%;
    margin-left: 0;
  }
  .Ticket {
    background-color: white;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 18px;
    font-size: 22px;
    line-height: 18px;
    position: fixed;
  }
  .pic
  {
    margin-top: 10px; 
    margin-bottom: 5px;
  }
  .pic img {
    width: 80%;
  }
  .rowTicket {
    /* padding-left: 10px; */
    padding: 0;
    /* height: 100%; */
  }
  .ticket {
    /* width: 80mm; */
    /* border: 1px solid black; */
    /* border:  none; */
    /* padding-left: 15px;
    margin-left: 16px; */
  }

  h1,
  h2,
  h3 {
    margin: 0;
  }

  h1 {
    font-size: 20px;
    font-family: 'Fira Code', monospace;
  }
  h2,
  h3,
  h4,
  .detalle,
  table,
  th,
  td,
  pre {
    font-size: 18px !important;
    font-family: 'Fira Code', monospace;
    text-transform: uppercase;
    font-weight: 300 !important;
  }
  .detalle {
    /* padding: 0!important; */
    margin: 0 auto;
  }
  .pageBreak {
    page-break-before : always;
    page-break-after: always;
    clear: both;
  }
  .table-bold-header{
    font-weight: bolder !important;
  }
  .table-normal-body{
    font-weight: 500 !important;
  }
}
</style>